module.exports = __webpack_public_path__ + "static/logo-5e5bf45e5b9e778643e0ea651183bb16.png";